import { create } from 'zustand';
export const useEnrichedAttributeListStore = create((set, get) => ({
  // État initial
  enrichedAttributeList: null,

  // Actions
  setEnrichedAttributeList: (newEnrichedAttributeList) => {
    set({
      enrichedAttributeList: newEnrichedAttributeList,
    });
  },

  clearEnrichedAttributeList: () => set({ enrichedAttributeList: null }),

  getEnrichedAttributeList: () => get().enrichedAttributeList,

  isEnrichedAttributeListLoaded: () => get().enrichedAttributeList === null,
}));
